// removed by extract-text-webpack-plugin
module.exports = {"toggle":"Switch__toggle___3A106","checked":"Switch__checked___1CE57","unchecked":"Switch__unchecked___3bB49"};